export const scrollIntoView = (
  id?: string,
  position?: ScrollLogicalPosition
) => {
  if (!id) return;
  const element = document.getElementById(id);
  if (!element) return;
  element.scrollIntoView({ behavior: 'smooth', block: position ?? 'center' });
};
